export const POSTS_TO_SHOW = 6;
